<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-bug-check</v-icon>{{$t('qualitycheck.test.test')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <QualityCheckValueForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import QualityCheckValueForm from '../../components/qualitycheckvalue/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'QualityCheckValue';

const { mapFields } = createHelpers({
  getterType: 'qualitycheckvalue/getField',
  mutationType: 'qualitycheckvalue/updateField'
});

export default {
  name: 'QualityCheckValueCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    QualityCheckValueForm
  },
  data() {
    return {
      item: {
        'qualityCheck' : this.$route.params.parent
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('qualitycheckvalue', ['create', 'reset'])
  }
};
</script>
